<template>
    <div class="auctions-counter" id="licznik">
        <div class="content-wrapper">
            <div class="counter-inner">
                <div v-if="!isLoading" class="counter-container">
                    <!-- <span class="counter-before">Allegro przekazało już:</span> -->
                    <div class="counter-itself">
                        <div class="counter-digits">
                            <div
                                v-for="(digit, index) in prepareAmountDigits"
                                :key="'digit-' + index"
                                class="digit"
                                :class="'digit-' + index"
                            >
                                <span>{{ digit }}</span>
                            </div>
                            <span class="currency">zł</span>
                        </div>
                        <div class="counter-after">
                            <span
                                @mouseenter="showTooltip()"
                                @mouseleave="hideTooltip()"
                                class="i-icon"> i
                                <div v-if="tooltipVisible" class="i-tooltip">Dotacje Allegro na walkę z COVID-19: Pakiet darmowych dostaw Allegro SMART! o wartości 325 mln zł, pakiety wsparcia dla sprzedających o wartości 155 mln zł, 2 mln zł dla WOŚP na zakup respiratorów, 2 mln zł na Fundusz Charytatywny pracowników, 1,08 mln zł na środki ochrony osobistej dla szpitali, 1,8 mln zł dla Fundacji Lekarze Lekarzom, 1 mln zł na wyposażenie laboratoriów prowadzących testy na COVID-19 w Warszawie i Poznaniu, 250 tys. zł dla pięciu organizacji pozarządowych wspierających środowisko literackie (Plebiscyt Książka Roku 2020) oraz 50 tys. zł dla Fundacji Wisławy Szymborskiej. Wpłaty użytkowników na rzecz Funduszu Interwencyjnego WOŚP - 213 865 zł, w celu wsparcia teatrów (#złotybilet) - 45 tys. zł oraz Unii Literackiej (akcjaliteracka.pl) - 24 tys. zł.
                                    <button
                                        @click.prevent="hideTooltip()"
                                        class="btn-close"
                                    >Zamknij</button>
                                </div>
                            </span>
                        </div>
                    </div>
                    <span class="counter-info-after">
                        na walkę z pandemią koronawirusa od Allegro, od naszych klientów i partnerów.<br />
                        <strong>Razem WYgramy!</strong>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import incomesJson from "@/generated/incomes.json";

export default {
    data() {
        return {
            isLoading: false,
            adminIncome: 0,
            auctionsIncome: 0,
            tooltipVisible: false
        };
    },
    computed: {
        prepareAmountDigits: function() {
            let currentAmount = this.totalAmount;
            let splitted = currentAmount.toString().split("");
            let splittedLength = splitted.length;

            if (splittedLength < 8) {
                for (let i = 0; i < 8 - splittedLength; i++) {
                    splitted.unshift("0");
                }
            }

            return splitted;
        },
        totalAmount: function () {
            return parseInt(this.adminIncome) + parseInt(this.auctionsIncome)
        }
    },
    methods: {
        showTooltip: function() {
            this.tooltipVisible = true;
        },
        hideTooltip: function() {
            this.tooltipVisible = false;
        },
        countInAdminIncome: function () {
            let cmp = this;
            if (incomesJson && incomesJson.totalIncome) {
                cmp.adminIncome = incomesJson.totalIncome;
            }
        },
        fetchAuctionsIncome: function() {
            if (Number.isInteger(window.allegro_auctions_amount)) {
                this.auctionsIncome = window.allegro_auctions_amount;
            }
        }
    },
    mounted() {
        this.countInAdminIncome();
        //this.fetchAuctionsIncome();
    }
};
</script>

<style lang="scss">
@import "@/scss/_general.scss";

.auctions-counter {
    .content-wrapper {
        .counter-inner {
            height: 200px;
            width: 100%;
            background: #ff5a00;
            background: url("../assets/images/counter-bg.png"), linear-gradient(0deg, #FF5A00 0%, #FF5A00C4 100%) 0% 0% no-repeat padding-box;
            background-size: contain;
            background-position: 50% 100%;
            background-repeat: no-repeat;

            @media only screen and (max-width: 768px) {
                height: auto;
                padding: 24px 0;
                text-align: center;
            }

            .counter-container {
                display: flex;
                flex-direction: column;
                color: #fff;
                justify-content: center;
                align-items: center;
                height: 100%;

                @media only screen and (max-width: 1200px) {
                    flex-direction: column;
                    // padding-top: 20px;
                }

                .counter-before {
                    font-size: 28px;
                    line-height: 40px;
                    font-weight: 100;
                    margin-bottom: 10px;

                    @media only screen and (max-width: 991px) {
                        font-size: 18px;
                        line-height: 18px;
                        margin-top: 10px;
                        text-align: center;
                        padding: 0 24px;
                    }
                }

                .counter-itself {
                    display: flex;

                    .counter-digits {
                        margin-left: 20px;
                        margin-right: 20px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        .currency {
                            font-size: 30px;
                            margin-left: 10px;
                            font-weight: 600;

                            @media only screen and (max-width: 768px) {
                                font-size: 16px;
                            }
                        }

                        .digit {
                            height: 80px;
                            font-size: 60px;
                            line-height: 80px;
                            color: #fff;
                            // background: #222226;
                            border-radius: 4px;
                            width: 55px;
                            text-align: center;
                            margin: 0 2px;
                            font-weight: 500;
                            position: relative;
                            z-index: 1;

                            &.digit-2, &.digit-5 {
                                margin-right: 12px;
                            }

                            @media only screen and (max-width: 768px) {
                                font-size: 30px;
                                line-height: 36px;
                                height: 35px;
                                width: 24px;

                                &.digit-2, &.digit-5 {
                                    margin-right: 4px;
                                }
                            }

                            // cień górny
                            &:before {
                                content: "";
                                position: absolute;
                                top: -2px;
                                left: 0;
                                width: 100%;
                                height: 10px;
                                background: #fff;
                                opacity: 0.85;
                                border-radius: 4px 4px 0 0;
                                z-index: 0;
                            }

                            // cień dolny
                            &:after {
                                content: "";
                                position: absolute;
                                bottom: -2px;
                                left: 4%;
                                width: 92%;
                                height: 4%;
                                background: #fff;
                                opacity: 0.4;
                                border-radius: 0 0 4px 4px;
                                z-index: -1;
                            }

                            span {
                                position: relative;
                                z-index: 1;
                                display: block;
                                width: 100%;
                                background: #222226;
                                border-radius: 4px;
                                height: 100%;

                                // pasek przecinający
                            &:before {
                                content: "";
                                width: 100%;
                                height: 1px;
                                position: absolute;
                                top: 50%;
                                left: 0px;
                                background: #fff;
                                opacity: 0.2;
                            }
                            }
                        }
                    }
                    .counter-after {
                        font-size: 16px;
                        line-height: 22px;
                        display: flex;
                        white-space: pre-wrap;
                        display: flex;
                        align-items: center;

                        strong {
                            font-weight: 700;
                        }

                        .i-icon {
                            position: relative;
                            margin-left: 10px;
                            color: #fff;
                            font-size: 11px;
                            border: 1px #fff solid;
                            width: 19px;
                            height: 19px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            border-radius: 99px;
                            margin-top: 2px;
                            cursor: pointer;

                            .i-tooltip {
                                background: #fff;
                                color: $headingText;
                                padding: 10px 15px;
                                z-index: 10;
                                position: absolute;
                                top: 32px;
                                left: -200px;
                                width: 400px;
                                border-radius: 4px;
                                font-size: 11px;
                                line-height: 18px;

                                -webkit-box-shadow: 0px 2px 10px 3px
                                    rgba(0, 0, 0, 0.34);
                                -moz-box-shadow: 0px 2px 10px 3px
                                    rgba(0, 0, 0, 0.34);
                                box-shadow: 0px 2px 10px 3px rgba(0, 0, 0, 0.34);

                                @media only screen and (max-width: 576px) {
                                    width: 95vw;
                                    position: fixed;
                                    top: initial;
                                    bottom: 15px;
                                    left: 2.5vw;
                                    height: auto;
                                }

                                &:before {
                                    content: "";
                                    width: 15px;
                                    height: 15px;
                                    background: #fff;
                                    position: absolute;
                                    top: -5px;
                                    left: calc(50% + 1.5px);
                                    transform: rotate(45deg);

                                    @media only screen and (max-width: 576px) {
                                        display: none;
                                    }
                                }

                                strong {
                                    margin-bottom: 5px;
                                    display: inline-block;
                                }

                                .btn-close {
                                    display: none;

                                    @media only screen and (max-width: 576px) {
                                        display: flex;
                                        margin-left: auto;
                                        color: $orange1;
                                    }
                                }
                            }
                        }

                        @media only screen and (max-width: 576px) {
                            display: none;
                        }
                    }
                }

                .counter-info-after {
                    font-size: 18px;
                    line-height: 28px;
                    font-weight: 100;
                    text-align: center;
                    margin-top: 15px;

                    strong {
                        font-weight: 600;
                    }

                    @media only screen and (max-width: 991px) {
                        font-size: 14px;
                        line-height: 18px;
                        margin-top: 10px;
                        text-align: center;
                        padding: 0 24px;
                    }
                }
            }
        }
    }
}
</style>
